module.exports = __webpack_public_path__ + "static/media/ArialMT.f5d900bb.woff";